const paymentTypes = {
  CASH: 'ch',
  CARD_TO_COURIER: 'cc',
  CARD_ONLINE: 'co',
};

export { paymentTypes };
